import { Expose, Type } from "class-transformer";
import { Persona } from "../../../../types/persona/persona.entity";
import type { IPersona } from "../../../../types/persona/persona.entity.interface";
import { HouseholdMemberRelationship } from "../../../../legacy/services/household/entities/household-member-relationship/household-member-relationship.entity";
import type { IHouseholdMemberRelationship } from "../../../../legacy/services/household/entities/household-member-relationship/household-member-relationship.entity.interface";
import type { IHouseholdMemberPersona } from "./household-member-persona.entity.interface";

export class HouseholdMemberPersona implements IHouseholdMemberPersona {
  @Expose()
  @Type(() => Persona)
  persona!: IPersona;

  @Expose()
  @Type(() => HouseholdMemberRelationship)
  relationship!: IHouseholdMemberRelationship;
}
